import { render, staticRenderFns } from "./saleRecords.vue?vue&type=template&id=775b3ada&"
import script from "./saleRecords.vue?vue&type=script&lang=js&"
export * from "./saleRecords.vue?vue&type=script&lang=js&"
import style0 from "./saleRecords.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports